import moment from "moment";

/**
 * Jackson LocalDateTime may arrive as string, array [y,m,d,h,mi,s] or object.
 * Java months are 1-based; moment months are 0-based.
 */
export function parseApiDateTime(value) {
  if (value == null || value === "") return null;

  if (Array.isArray(value)) {
    const [year, month, day, hour = 0, minute = 0, second = 0] = value;
    if (!year || !month || !day) return null;
    const parsed = moment({ year, month: month - 1, day, hour, minute, second });
    return parsed.isValid() ? parsed : null;
  }

  if (typeof value === "object" && !(value instanceof Date)) {
    if (value.year && (value.monthValue || value.month) && (value.dayOfMonth || value.day)) {
      const parsed = moment({
        year: value.year,
        month: (value.monthValue || value.month) - 1,
        day: value.dayOfMonth || value.day,
        hour: value.hour || 0,
        minute: value.minute || 0,
        second: value.second || 0,
      });
      return parsed.isValid() ? parsed : null;
    }
  }

  const parsed = moment(value);
  if (parsed.isValid()) return parsed;

  const formatted = moment(value, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DDTHH:mm:ss", "DD.MM.YYYY HH:mm"], true);
  return formatted.isValid() ? formatted : null;
}

export function formatApiDateTime(value, pattern = "DD.MM.YYYY HH:mm") {
  const parsed = parseApiDateTime(value);
  return parsed ? parsed.locale("tr").format(pattern) : "-";
}

/**
 * Calendar-day relative labels — aligned with notification group headers (Bugün, Dün, …).
 * moment.fromNow() uses hour thresholds (~36h → "2 gün önce"), which breaks midnight start dates.
 */
export function formatApiRelativeDateTime(value) {
  const parsed = parseApiDateTime(value);
  if (!parsed) return "";

  const now = moment().locale("tr");
  const date = parsed.locale("tr");

  if (date.isAfter(now, "day")) {
    const daysAhead = date.startOf("day").diff(now.clone().startOf("day"), "days");
    if (daysAhead === 1) return "Yarın";
    if (daysAhead < 7) return `${daysAhead} gün sonra`;
    return date.format("DD.MM.YYYY");
  }

  if (date.isSame(now, "day")) return "Bugün";
  if (date.isSame(now.clone().subtract(1, "day"), "day")) return "Dün";

  const daysAgo = now.clone().startOf("day").diff(date.startOf("day"), "days");
  if (daysAgo < 7) return `${daysAgo} gün önce`;
  if (date.isSame(now, "month")) return date.format("D MMMM");
  return date.format("MMMM YYYY");
}
